import { render, staticRenderFns } from "./PU30.vue?vue&type=template&id=bf45c8e2&scoped=true&"
import script from "./PU30.vue?vue&type=script&lang=js&"
export * from "./PU30.vue?vue&type=script&lang=js&"
import style0 from "./PU30.vue?vue&type=style&index=0&id=bf45c8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf45c8e2",
  null
  
)

export default component.exports